$(document).ready(function(){


    $('html').removeAttr("style");

    /*if ($(".social-buttons").length) {
        $( '.social-buttons a' ).click(function( e ){
            e.preventDefault();
            m40_socialShare( this.href, 640, 480 );
        });
        window.m40_socialShare = function(url, winWidth, winHeight) {
            var winTop = (window.innerHeight / 2) - (winHeight / 2);
            var winLeft = (window.innerWidth / 2) - (winWidth / 2);
            window.open(url, 'm40_sharer', 'top=' + winTop + ',left=' + winLeft + ',toolbar=0,status=0,width=' + winWidth + ',height=' + winHeight);
            return false;
        };
    }*/

    /*if ($(".chosen").length) {
        $(".chosen > .ginput_container > select").chosen();
    }

    if ($(".flatpickr").length) {
        $(".flatpickr > .ginput_container > input").flatpickr();
    }*/

    // Search Container - Trigger is in secondary-navigation.twig
    $(".search-trigger").on('click', function(e) {
        e.preventDefault();
        $(".search-container").toggleClass("active");
        if ($(".search-container").hasClass("active"))
        {
            setTimeout( function()
            { 
                $('#auto-search').focus();
            }, 250);
        }

    });

    $(".close-book-a-tour").on('click', function(e) {
        e.preventDefault();
        window.setCookie("hide_book_a_tour", 1, 60 * 60 * 24);
        $("#bookATourNavBar").addClass("hidden-by-user")
    });

    $(".search-close").on('click', function(e) {
        e.preventDefault();
        $(".search-container").removeClass("active");
    });

    if ($('.fancybox').length)
    {
        $(".fancybox").fancybox(
            {
                beforeShow : function()
                {
                    this.title =  $(this.element).data("caption");
                },
                openEffect: "none",
                closeEffect: "none",

                helpers:
                    {
                        overlay:
                            {
                                css: { 'background': 'rgba(236, 236, 236, 0.8)' }
                            }
                    }
            });
    }


    // esc key action
    $(document).keyup(function(e) 
    {
        if (e.keyCode == 27) 
        { // Esc

            $('#featuredInfoWindow').slideUp(); // hide the faux infowindow on maps 
            $('#protectedDownloadsModal').modal('hide');

            $("html").removeClass("search-is-open");
            $("html").removeClass("nav-is-open");
            $("html").removeClass("aux-nav-is-open");

        }
    });


});
